export default __webpack_public_path__ + "static/ShareSection1_es-94f8fadb0d6fe24392bfb1db3c241732.png";